"use strict";
import React from "react";
import Toggle from "../Toggle/Toggle";
const ToggleGroup = ({
  name,
  on,
  items,
  disabled,
  onGroupToggle,
  onItemToggle
}) => /* @__PURE__ */ React.createElement("div", { className: "toggle-group" }, /* @__PURE__ */ React.createElement("div", { className: "toggle-group__container" }, /* @__PURE__ */ React.createElement("div", { className: "toggle-group__name" }, /* @__PURE__ */ React.createElement(Toggle, { disabled, value: on, label: name, onChange: () => onGroupToggle() })), /* @__PURE__ */ React.createElement("div", { className: "toggle-group__items" }, items.map((item) => /* @__PURE__ */ React.createElement("div", { key: String(item.id), className: "toggle-group__item" }, /* @__PURE__ */ React.createElement(Toggle, { disabled, value: item.value, label: item.label, onChange: () => onItemToggle(item.id) }))))));
export default ToggleGroup;
